/* eslint-env browser */
import moment from 'moment-timezone';
import getFeaturedVariant from './featured';
import defaultFeaturedMessages from '../data/announcements.json';

export function filterByNextAnnouncements(collection) {
  const currentDate = moment().unix();
  return collection.filter(item => {
    const startDate = moment(`${item.startDateForDisplaying} 00:00`).unix();
    const finishDate = moment(`${item.finishDateForStopDisplaying} 23:59`).unix();
    return currentDate >= startDate && currentDate <= finishDate;
  });
}
export function findById(collection, id) {
  return collection.find(item => item.id === id);
}
export function filterIgnoredItems(collection, ignored) {
  return collection.filter(item => !ignored.includes(item.id));
}

export function getAnnouncement(announcements) {
  const featuredMessages = announcements || defaultFeaturedMessages;
  const annoucementState =
    localStorage.annoucementState && JSON.parse(localStorage.annoucementState);
  let announcement = getFeaturedVariant(filterByNextAnnouncements(featuredMessages));
  if (!announcement) return null;
  let data = {
    displaying: { id: announcement.id, counter: 1 },
    date: moment().format('YYYY-MM-DD'),
    displayed: [announcement.id]
  };

  if (annoucementState) {
    const { displaying, date, displayed } = annoucementState;
    announcement = findById(featuredMessages, displaying.id);
    if (!announcement) return null;
    const currentDate = moment().unix();
    const finishDate = moment(`${date} 23:59`).unix();
    if (displaying.counter <= announcement.maxTimesDisplayed - 1 && currentDate <= finishDate) {
      data = {
        displaying: { id: announcement.id, counter: displaying.counter + 1 },
        date: moment().format('YYYY-MM-DD'),
        displayed
      };
    } else {
      if (currentDate <= finishDate) return null;
      announcement = getFeaturedVariant(
        filterByNextAnnouncements(filterIgnoredItems(featuredMessages, displayed))
      );
      if (!announcement) return null;
      data = {
        displaying: { id: announcement.id, counter: 1 },
        date: moment().format('YYYY-MM-DD'),
        displayed: displayed.concat([announcement.id])
      };
    }
  }

  localStorage.annoucementState = JSON.stringify(data);
  return announcement;
}

export function setAnnouncementCounter(announcementId, newCounter) {
  const annoucementState =
    localStorage.annoucementState && JSON.parse(localStorage.annoucementState);
  if (annoucementState) {
    annoucementState.displaying.counter = newCounter;
    localStorage.annoucementState = JSON.stringify(annoucementState);
  }
}



// WEBPACK FOOTER //
// ./src/utils/announcements.js